// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1KFCI","actions":"GroupTable_actions__cm4i8","deleteModalFooter":"GroupTable_deleteModalFooter__BY7we"};